import { create } from 'zustand'
import { persist } from 'zustand/middleware'

function decodeTokenRole(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return payload.role ?? null
  } catch {
    return null
  }
}

interface AuthState {
  token: string | null
  refreshToken: string | null
  userId: string | null
  role: string | null
  setAuth: (token: string, refreshToken: string, userId?: string, role?: string) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      userId: null,
      role: null,
      setAuth: (token, refreshToken, userId, role) =>
        set((prev) => ({
          token,
          refreshToken,
          userId: userId ?? prev.userId,
          role: role ?? decodeTokenRole(token) ?? prev.role,
        })),
      clearAuth: () => set({ token: null, refreshToken: null, userId: null, role: null }),
    }),
    { name: 'enghustle-auth' },
  ),
)
